<template>
  <div>
    <!-- <handle-assign-stock-sidebar ref="assignStockSidebar" /> -->

    <div class="flex justify-center items-center py-2 px-8" style="background-color: #eaeaea; margin-left: -32px; margin-right: -32px">
      <div class="absolute left-0 ml-8 font-bold" style="color: #ff000044">Procurement view</div>
      <venue-selector
        :value="value"
        @input="$emit('input', $event)"
        style="width: 350px"
        :filterCountries="[activeCountry.name]"
        :globalMode="true"
        :multiple="false"
      />
    </div>

    <div v-if="value" class="mt-8">
      <slot></slot>
    </div>
    <div
      v-else
      class="mt-10 my-auto vx-col flex items-center align-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-2/4 xl:w-2/4 mx-auto text-center"
    >
      <img src="@/assets/images/no_venue_selected.png" alt="graphic-404" class="mx-auto mb-4" style="width: 150px" />
      <h5 class="sm:mx-0 mx-4 mt-4 text-xl d-theme-text">Select a venue to continue</h5>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VenueSelector from "@/components/VenueSelector.vue";

export default {
  components: { VenueSelector },
  props: {
    value: {
      type: String | null,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      activeCountry: "venues/activeCountry"
    })
  }
};
</script>

